import { render, staticRenderFns } from "./pczb.vue?vue&type=template&id=9935858a&scoped=true&"
import script from "./pczb.vue?vue&type=script&lang=js&"
export * from "./pczb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9935858a",
  null
  
)

export default component.exports